export enum ProductType {
  GOAL = 'GOAL',
  GOAL_PACKAGE = 'GOAL_PACKAGE',
  IMPRV_COINS = 'IMPRV_COINS'
}

export interface ProductGoalDataModel {
  goalEntityId: string;
}

export interface ProductPackageDataModel {
  packageId: string;
}

export interface ProductImprvCoinsDataModel {
  packageSku: string;
}

export type PaymentSessionProductModel =
  | { type: ProductType.GOAL; data: ProductGoalDataModel }
  | { type: ProductType.GOAL_PACKAGE; data: ProductPackageDataModel }
  | { type: ProductType.IMPRV_COINS; data: ProductImprvCoinsDataModel };

export enum PaymentProvider {
  STRIPE = 'STRIPE',
  PAYU = 'PAYU'
}

export interface PaymentSessionCreateModel {
  product: PaymentSessionProductModel;
  // Affiliator referral code captured from the ?ref= link the buyer arrived through.
  referralCode?: string;
  // Which payment provider the buyer chose (the two landing-page buttons). Omitted => STRIPE.
  paymentProvider?: PaymentProvider;
}

export enum PaymentSessionReason {
  PRODUCT_ALREADY_ACQUIRED = 'PRODUCT_ALREADY_ACQUIRED',
  PRODUCT_IS_FREE = 'PRODUCT_IS_FREE',
  SESSION_CREATED = 'SESSION_CREATED'
}

export interface PaymentSessionModel {
  sessionRedirectUrl?: string | null;
  reason?: PaymentSessionReason | null;
}
